'use strict';

const cookies = require('cookies-js');

window.onGaReady = tracker =>
	cookies.set('gaCid', tracker.get('clientId'));